module.exports = __webpack_public_path__ + "static/img/yh2.1fadd04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/yh2.png
// module id = 50UA
// module chunks = 1